/**
 * Marker viewer / metadata chrome inside Google Maps InfoWindow.
 * Slideshow layout lives in mediaShell; .gm-style overrides in thirdParty/.
 * Toolbar actions use Button size="lg".
 */

import { chromeShell } from "./chromeShell";
import { controlHeight, fieldText, typeShell } from "./typeShell";

const { scrollThin } = chromeShell;

const fieldLayout =
    "box-border flex w-full shrink-0 items-center justify-start rounded-md border border-solid border-border-light bg-surface-muted px-3 py-0 leading-none bp-md:px-3.5 bp-2xl:px-4 max-[440px]:px-2";

const fieldBase = `${fieldLayout} ${controlHeight} ${fieldText} max-[440px]:h-10 max-[440px]:text-xs`;

export const markerViewerShell = {
    /* —— InfoWindow outer (full bleed; slideshow wrapper supplies gutters) —— */
    container:
        "box-border m-0 flex !h-full !max-h-full !min-h-0 !w-full !max-w-full flex-col overflow-hidden !p-0 bg-surface font-sans",

    /* —— Metadata page: compact on regular iPad; roomier on Pro (bp-2xl) —— */
    metadata: `box-border flex h-full w-full flex-col justify-center gap-5 self-center overflow-x-hidden overflow-y-auto px-3 py-6 bp-md:gap-6 bp-md:px-5 bp-md:py-8 bp-2xl:gap-12 bp-2xl:px-10 bp-2xl:py-16 max-[440px]:gap-5 max-[440px]:px-3 max-[440px]:py-8 ${scrollThin}`,

    buttonsWrap:
        "flex w-full shrink-0 flex-row items-center justify-between gap-3 bp-2xl:gap-4 max-[440px]:gap-2",

    aiChatButton: "shrink-0",
    editButton: "shrink-0",

    mainInfo: "w-full shrink-0",

    row: "box-border flex w-full flex-col items-stretch gap-3 bp-md:flex-row bp-2xl:gap-4 max-[440px]:gap-3",

    titleSection:
        "box-border flex min-w-0 w-full flex-1 flex-col gap-1.5",
    labelSection:
        "box-border flex min-w-0 w-full flex-1 flex-col gap-1.5",

    viewerLabel:
        `mb-0 hidden text-left leading-none bp-md:block max-[440px]:!hidden ${typeShell.fieldLabel}`,

    viewerField: `${fieldBase} whitespace-pre-wrap`,

    /** Same height as labelField — do not bump text size here (breaks side-by-side align). */
    viewerTitle: `${fieldBase} font-semibold`,

    labelField: `${fieldBase} gap-2`,

    labelDot:
        "inline-block size-4 shrink-0 rounded-full shadow-[0_0_0_0.0625rem_rgba(0,0,0,0.1)]",

    metaSection: "w-full shrink-0",

    metaField: `${fieldBase} flex-row justify-start gap-4`,

    metaItem:
        "mb-0 flex flex-1 items-center justify-between gap-2 border-0 border-solid border-transparent px-3 py-1.5 [&:not(:last-child)]:mr-2 [&:not(:last-child)]:border-r [&:not(:last-child)]:border-border-subtle [&:not(:last-child)]:pr-4 last:border-b-0 last:pl-2",

    metaLabel: `min-w-14 bp-2xl:min-w-16 ${typeShell.metaLabel}`,
    metaValue: `flex-1 text-right ${typeShell.metaValue}`,
};
